import { c as _c } from "react/compiler-runtime";
import SvgCheck from '@common/__generated__/icon/SvgCheck';
import { cn } from '@core/utils';
import { Image } from '@/components/client';
interface ChallengeListItemProps {
  label: string;
  benefit: string;
  image: {
    url: string;
    alt: string;
  };
  isCompleted: boolean;
}
export const ChallengeListItem = t0 => {
  const $ = _c(27);
  const {
    label,
    benefit,
    image,
    isCompleted
  } = t0;
  let t1;
  if ($[0] !== isCompleted) {
    t1 = cn("flex items-center justify-between rounded-medium bg-Gray-white px-20", {
      "bg-[linear-gradient(90deg,_var(--Color-Red-R-400,_#FF403D)_0%,_var(--Color-Red-R-500,_#F50000)_100%)]": isCompleted
    });
    $[0] = isCompleted;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isCompleted) {
    t2 = cn("flex w-fit items-center gap-4 rounded-xsmall border border-R-400 px-8 py-6 flex-center", {
      "bg-Gray-white": isCompleted
    });
    $[2] = isCompleted;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label) {
    t3 = <p className="font-800 text-R-400 typo-body4">{label}</p>;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isCompleted) {
    t4 = isCompleted && <SvgCheck className="size-14 text-R-400" />;
    $[6] = isCompleted;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isCompleted) {
    t6 = cn("whitespace-pre-line font-800 !leading-[120%] text-Gray-black typo-body2", {
      "text-Gray-white": isCompleted
    });
    $[12] = isCompleted;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== benefit || $[15] !== t6) {
    t7 = <p className={t6}>{benefit}</p>;
    $[14] = benefit;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="flex flex-col gap-8">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== image.alt || $[21] !== image.url) {
    t9 = <Image src={image.url} alt={image.alt} width={232.5} height={178.5} className="h-119 w-155" />;
    $[20] = image.alt;
    $[21] = image.url;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t1 || $[24] !== t8 || $[25] !== t9) {
    t10 = <li className={t1}>{t8}{t9}</li>;
    $[23] = t1;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};